import React from 'react';
import { Link } from 'react-scroll';
import { SideBarNavItemType } from '@/common';
import styles from '@/styles/SideBarNav.module.scss';

export const SideBarNavItem = ({
  url = '',
  title,
  parent,
  isActive,
  width,
  navigateToDifferentPart,
}: SideBarNavItemType & {
  width: number;
  isActive: string;
  navigateToDifferentPart: (isNewActive: string) => void;
}) => {
  const isLp = title.toLowerCase() === 'lp';
  const isGp = title.toLowerCase() === 'gp';
  const isLpVisible = isLp && width > 768;
  const isGpVisible = isGp && width > 768;
  const isLinkVisible = title.toLowerCase() !== 'lp' && title.toLowerCase() !== 'gp' && width > 768;

  if (isLp || isGp) {
    if (isLpVisible || isGpVisible) {
      return (
        <li className={`${styles['sidebar-item']} ${styles['sidebar-item-parent-cursor']}`}>
          <span className={styles['sidebar-item-parent']}>{title}</span>
        </li>
      );
    } else return <></>;
  }

  if (isLinkVisible) {
    return (
      <li className={styles['sidebar-item']}>
        <Link
          to={url}
          spy={true}
          smooth={true}
          offset={-40}
          duration={500}
          onSetActive={() => {
            navigateToDifferentPart(title);
          }}
        >
          <span
            className={`${styles['sidebar-item-link']} ${
              isActive === title && styles['sidebar-item-link--active']
            }`}
            onClick={() => {
              setTimeout(() => {
                navigateToDifferentPart(title);
              }, 500);
            }}
          >
            {title}
          </span>
        </Link>
      </li>
    );
  }

  return (
    <Link
      to={url}
      spy={true}
      smooth={true}
      offset={width <= 786 ? -70 : 0}
      duration={500}
      onSetActive={() => {
        navigateToDifferentPart(title);
      }}
    >
      <span
        className={`${styles['sidebar-item-link']} ${
          isActive === title && styles['sidebar-item-link--active']
        }`}
      >
        {title} {parent && `(${parent})`}
      </span>
    </Link>
  );
};
